const coverDateLabels = {
  renewal: 'renewalDate',
  start: 'startDate',
  lapsed: 'expiredDate',
  cancelled: 'cancellationDate',
  email: 'emailAddress',
};
export default coverDateLabels;
